import FilterProvider from "./_helper/Filter/FilterProvider";
import AnimationThemeProvider from "./_helper/AnimationTheme/AnimationThemeProvider";
import CustomizerProvider from "./_helper/Customizer/CustomizerProvider";
import UserProvider from "./_helper/User/UserProvider";
import LabelProvider from "./_helper/Label/LabelProvider";
import { AuthProvider } from "./_helper/Auth/AuthProvider";
import ErrorBoundary from "./Components/ErrorBoundary";
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const status = error?.response?.status;
        if (status === 429 || status === 401 || status === 403 || status === 404) {
          return false;
        }
        return failureCount < 2;
      },
    },
  },
});
const Providers = ({ children }) => (

  
  <AuthProvider>
     <QueryClientProvider client={queryClient}>
    <CustomizerProvider>
      <FilterProvider>
        <UserProvider>
          <LabelProvider>
            <AnimationThemeProvider>{children}</AnimationThemeProvider>
          </LabelProvider>
        </UserProvider>
      </FilterProvider>
    </CustomizerProvider>
    </QueryClientProvider>
  </AuthProvider>
);

export default Providers;
